///
/// EarthBrowser
///
/// Migration v37 to v38: Add conversion-prompt bookkeeping to engagement
/// Created by Matt Giger on 9/13/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v37 to v38
 *
 * Changes:
 * - Adds conversion-ladder prompt bookkeeping to the engagement slice:
 *   interstitial once-per-day tracking, lifetime show count (drives the
 *   escalating dismiss delay), refresh-survival pending delay, and the
 *   per-day dismissal for the rung-1 banner.
 * - Absorbs the legacy SupportInterstitial localStorage keys: the lifetime
 *   show count carries over (so dismiss-delay escalation is preserved) and
 *   the old keys are removed.
 */
export function migrateV37toV38(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	const engagement = (s.engagement && typeof s.engagement === "object")
		? s.engagement as Record<string, unknown>
		: {}
	if ("interstitialShowCount" in engagement) return state

	// Carry the legacy nag counter into the slice, then retire the old keys
	let legacyShowCount = 0
	try {
		if (typeof localStorage !== "undefined") {
			legacyShowCount = Number.parseInt(localStorage.getItem("eb-support-nag-count") ?? "0", 10) || 0
			localStorage.removeItem("eb-support-nag-last-shown")
			localStorage.removeItem("eb-support-nag-count")
			localStorage.removeItem("eb-support-nag-pending")
		}
	} catch { /* localStorage unavailable: start the counter fresh */ }

	return {
		...s,
		engagement: {
			...engagement,
			interstitialLastShownDay: null,
			interstitialShowCount: legacyShowCount,
			interstitialPendingDelay: null,
			bannerDismissedDay: null,
		},
	}
}
